import { Moon, Sun } from 'lucide-react';

import { type SettingsCommand } from '../types';

export const settingsCommands: SettingsCommand[] = [
  {
    id: 'theme-light',
    labelKey: 'settings.lightMode',
    icon: Sun,
    keywords: ['theme', 'tema', 'claro', 'light', 'bright'],
    action: 'theme-light',
  },
  {
    id: 'theme-dark',
    labelKey: 'settings.darkMode',
    icon: Moon,
    keywords: ['theme', 'tema', 'escuro', 'dark', 'night'],
    action: 'theme-dark',
  },
];
